module.exports = __webpack_public_path__ + "img/vectortc.53923536.png";